import dayjs from 'dayjs';
import './index.less';
import React from 'react';
export var getUserInfo = function getUserInfo() {
  return JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
};
function calcPageHeight(doc) {
  var cHeight = Math.max(doc.body.clientHeight, doc.documentElement.clientHeight);
  var sHeight = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight);
  var height = Math.max(cHeight, sHeight);
  return height;
}
export function CmsReview() {
  var props = JSON.parse(sessionStorage.getItem('preview') || '{}');
  var title = props.title,
    publishDatetime = props.publishDatetime,
    createdEmplName = props.createdEmplName,
    content = props.content,
    _props$attachments = props.attachments,
    attachments = _props$attachments === void 0 ? [] : _props$attachments;
  var iframeLoad = function iframeLoad() {
    var iframeDom = document.getElementById('iframe_content');
    if (iframeDom) {
      // 获取iframe html文件
      // @ts-ignore
      var doc = iframeDom.contentWindow.document;
      // 获取iframe html文件head
      var head = doc.getElementsByTagName('head');
      // 新建link标签
      var linkTag = document.createElement('link');
      // 设置link标签id
      linkTag.id = 'newstyle';
      // link标签引入css文件的地址 ；window.STATIC_URL 是全局变量，指向静态资源目录，需要自己指定
      linkTag.href = "/public/css/iframe.css";
      // 设置link标签属性
      linkTag.setAttribute('rel', 'stylesheet');
      // 设置link标签属性
      linkTag.setAttribute('type', 'text/css');
      // 将link标签添加进iframe html文件的head里
      head[0].append(linkTag);
      // @ts-ignore
      var timer = setTimeout(function () {
        clearTimeout(timer);
        //解决打开高度太高的页面后再打开高度较小页面滚动条不收缩
        iframeDom.style.height = '0px';
        // @ts-ignore
        var iDoc =
        // @ts-ignore
        iframeDom.contentDocument ||
        // @ts-ignore
        iframeDom.document ||
        // @ts-ignore
        iframeDom.contentWindow;
        var height = Math.max(calcPageHeight(iDoc));
        iframeDom.style.height = height + 'px';
      }, 200);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "container-cms"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("a", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/logo/logo_lj.svg",
    height: "28px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cms-full-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "des"
  }, /*#__PURE__*/React.createElement("div", {
    className: "desbox"
  }, "\u9605\u8BFB\uFF1A", /*#__PURE__*/React.createElement("span", {
    id: "readnum"
  }, "0")), /*#__PURE__*/React.createElement("div", {
    className: "desbox"
  }, publishDatetime ? dayjs(publishDatetime).format('YYYY-MM-DD HH:mm') : ''), "\xB7", /*#__PURE__*/React.createElement("div", {
    className: "desbox"
  }, getUserInfo().employeeName))), /*#__PURE__*/React.createElement("div", {
    className: "details-box"
  }, /*#__PURE__*/React.createElement("div", {
    id: "tinymce",
    className: "ql-editor ql-editor-content mce-content-body"
  }, /*#__PURE__*/React.createElement("iframe", {
    id: "iframe_content",
    title: "\u5185\u5BB9",
    srcDoc: content,
    // height={'100%'}
    width: '100%',
    // scrolling="no"
    style: {
      border: 'none'
    },
    onLoad: iframeLoad
  }))), Array.isArray(attachments) && attachments.length > 0 ? ( /*#__PURE__*/React.createElement("div", {
    id: "details-box",
    className: "details-box"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rowDetail-label"
  }, "\u9644\u4EF6\uFF1A"), /*#__PURE__*/React.createElement("ul", {
    className: "rowDetail-content"
  }, (attachments || []).map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id
    }, /*#__PURE__*/React.createElement("a", {
      href: item.fileSrcUrl
    }, item.fileName));
  })))) : null, /*#__PURE__*/React.createElement("div", {
    className: "details-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-btn"
  }, /*#__PURE__*/React.createElement("i", {
    id: "pre-icon",
    "aria-label": "\u56FE\u6807: left",
    className: "anticon anticon-left",
    style: {
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "64 64 896 896",
    "data-icon": "left",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
  }))), /*#__PURE__*/React.createElement("span", {
    id: "pre"
  })), /*#__PURE__*/React.createElement("div", {
    className: "page-btn"
  }, /*#__PURE__*/React.createElement("span", {
    id: "next"
  }), /*#__PURE__*/React.createElement("i", {
    id: "next-icon",
    "aria-label": "\u56FE\u6807: right",
    className: "anticon anticon-right",
    style: {
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "64 64 896 896",
    "data-icon": "right",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"
  }))))))));
}